module.exports = __webpack_public_path__ + "img/accounting.28ced2be.png";